import { mapActions, mapGetters } from 'vuex'

import { get } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import render from './render'

const getDiff = reset => {
  const now = Math.floor(Date.now() / 1000)

  return reset - now
}

export default {
  name: 'Template',

  data() {
    return {
      payload: {
        username: undefined,
        password: undefined
      },

      formValidation: false,

      interval: undefined,
      count: 0,
      limit: 5,
      remaining: undefined
    }
  },

  computed: {
    ...mapGetters({
      errors: 'login/errors',
      status: 'login/status'
    }),

    infoStyle() {
      let width = '400px'
      if (this.viewport.size.width < 768) {
        width = '360px'
      }

      return {
        minWidth: width,
        maxWidth: width
      }
    }
  },

  watch: {
    errors: {
      handler(value) {
        if (value.error) {
          if (value.error === 429) {
            const reset = Number(get(value, 'x-ratelimit-reset'))
            if (reset) {
              const diff = getDiff(reset)
              if (diff > 0) {
                this.makeInterval(reset)
              }
            }
          }
          const limit = get(value, 'x-ratelimit-limit')
          if (limit) {
            this.limit = Number(limit)
          }
          const remaining = get(value, 'x-ratelimit-remaining')
          if (remaining) {
            this.remaining = Number(remaining)
          }
          if (value.message) {
            this.addSnackbar({
              type: Colors.error,
              text: value.message
            })
          }
        } else {
          clearInterval(this.interval)
          this.interval = undefined
          this.count = 0
          this.limit = undefined
          this.remaining = undefined
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({ login: 'login/login' }),

    makeInterval(reset) {
      this.count = getDiff(reset)
      this.interval = setInterval(() => {
        if (this.count > 0) {
          this.count -= 1
        } else {
          clearInterval(this.interval)
          this.interval = undefined
          this.count = 0
          this.limit = undefined
          this.remaining = undefined
        }
      }, 1000)
    }
  },

  render
}
